package org.hs_soft.runmynesto.pages.home.sub_page.options

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.traceEventEnd
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.OptionInfoHeaders
import org.hs_soft.runmynesto.pages.components.LoadingProgress
import org.hs_soft.runmynesto.pages.components.TopTabItems
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.OptionsDialogs
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_flow.CashFlow
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.CashRegisterConfiguration
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.export.Export
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.printer_location.PrinterLocations
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.menu_card_import.MenuCardImportTab
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.operation.OptionOperationTab
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.price_category.PriceCategory
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.RestaurantManager
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.sales_group.OptionSaleGroupTab
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.virtual_card.VirtualCard
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsViewModel
import kotlin.reflect.KFunction1


@Composable
fun Options(
    windowSizeMode: WindowSizeModeEnum,
    mainTabsClickable: MutableState<Boolean>,
    viewModel: OptionsViewModel,
) {
    val state by viewModel.state.collectAsState()

    LaunchedEffect(state.areTabsClickable){
        mainTabsClickable.value=state.areTabsClickable
    }

    LaunchedEffect(Unit) {
        viewModel.onEvent(OptionsEvent.GetAppConfig)
        viewModel.onEvent(OptionsEvent.GetCheckoutData)
        viewModel.onEvent(OptionsEvent.OnLoadingOperationData)
        viewModel.onEvent(OptionsEvent.GetApaleoProperties)
        viewModel.onEvent(OptionsEvent.GetApaleoPaymentMethods)
        viewModel.onEvent(OptionsEvent.GetOptionCreditCards)
        viewModel.onEvent(OptionsEvent.GetCashRegisterGlobal)
        viewModel.onEvent(OptionsEvent.GetPriceLevels)
    }

    Column(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth()
    ) {

        TopTabItems(
            fillMaxWidth = true,
            windowSizeMode = windowSizeMode,
            selectedTab = state.selectedTab,
            tabItems = OptionInfoHeaders.entries,
            onTabClick = {
                viewModel.onEvent(OptionsEvent.OnTopTabClick(it))
            }
        )

        Box(
            modifier = Modifier
                .fillMaxHeight()
                .fillMaxWidth()
        ) {
            when(state.selectedTab) {

                OptionInfoHeaders.OPERATION -> {
                    OptionOperationTab(
                        windowSizeMode = windowSizeMode,
                        optionModel = state.optionModel,
                        onChangeDataOption = { title, value ->
                            viewModel.onEvent(OptionsEvent.UpdateOptionData(title, value))
                        },

                    )
                }

                OptionInfoHeaders.SALES_GROUP -> {
                    OptionSaleGroupTab(
                        state = state,
                        event = viewModel::onEvent,
                        windowSizeMode = windowSizeMode,
                    )
                }

                OptionInfoHeaders.PRINTER_LOCATIONS -> {
                    PrinterLocations(
                        state = state,
                        event = viewModel::onEvent,
                        windowSizeMode = windowSizeMode
                    )
                }

                OptionInfoHeaders.CASH_FLOW -> {
                    CashFlow(
                        state = state,
                        event = viewModel::onEvent,
                        windowSizeMode = windowSizeMode,
                    )
                }

                OptionInfoHeaders.PRICE_CATEGORY->{
                    PriceCategory(
                        state=state,
                        event=viewModel::onEvent,
                        windowSizeMode=windowSizeMode,
                    )
                }

                OptionInfoHeaders.VIRTUAL_CARD -> {
                    VirtualCard(
                        state = state,
                        event = viewModel::onEvent,
                        windowSizeMode = windowSizeMode,
                    )
                }


                OptionInfoHeaders.CASH_REGISTER_CONFIG -> {
                    CashRegisterConfiguration(
                        state = state,
                        event = viewModel::onEvent,
                        windowSizeMode = windowSizeMode,
                    )
                }

                OptionInfoHeaders.EXPORT->{
                    Export(
                        state=state,
                        event=viewModel::onEvent,
                        windowSizeMode=windowSizeMode,
                    )
                }

                OptionInfoHeaders.MENU_CARD_IMPORT -> {
                    MenuCardImportTab(
                        state = state,
                        event = viewModel::onEvent,
                        windowSizeMode = windowSizeMode,
                    )
                }


                OptionInfoHeaders.RESTAURANT_MANAGER -> {
                    RestaurantManager(
                        state = state,
                        event = viewModel::onEvent,
                        windowSizeMode = windowSizeMode,
                    )
                }
            }
        }
    }

    LoadingProgress(
        visibility = state.isLoading,
        loadingTitle = state.dataLoadingProgressTitle
    )

    OptionsDialogs(
        state = state,
        event = viewModel::onEvent,
        windowSizeMode = windowSizeMode
    )

}



